import { Auditable, Dto } from '@damofire/data-commons';
import { PartialDivision } from './organization.dto';

export enum PreferenceType {
  OFFLINE = 'offline',
  NOTIFICATION = 'notification',
  SYNC = 'sync',
  SURVEY = 'survey',
}

export interface Preference<T> extends Dto, Auditable {
  user: string;
  key: string;
  type: PreferenceType;
  value: T;
}

export type Offline = Preference<PartialDivision> & { type: PreferenceType.OFFLINE };
